import { Opportunity, OppyReport } from '@domain'

export const tatooineFileName = 'Tatooine/Mos Eisley/oppy.xlsx'
export const enterpriseFileName = 'Enterprise/Kirk/1977/report.xlsx'
export const ziggyFileName = 'Ziggy Stardust/1972 MAY/report.xlsx'

export const oppyReport = (overrides: Partial<OppyReport> = {}): OppyReport => ({
	fileName: tatooineFileName,
	startDate: '1977-05-01',
	endDate: '1977-05-31',
	...overrides,
})

export const oppyReports: OppyReport[] = [
	oppyReport({
		fileName: enterpriseFileName,
		startDate: '1977-09-01',
		endDate: '1977-09-30',
	}),
	oppyReport(),
	oppyReport({
		fileName: ziggyFileName,
		startDate: '1972-05-01',
		endDate: '1972-05-31',
	}),
]

export const oppyReportsRes: PaginatedAPIRes<OppyReport[]> = {
	data: oppyReports,
	pagination: {
		page: 1,
		pageSize: 100,
		total: oppyReports.length,
		totalPages: 1,
	},
}

export const opportunity = (overrides: Partial<Opportunity> = {}): Opportunity => ({
	id: 1,
	sourceRelativePath: tatooineFileName,
	dataStartDate: '1977-05-01',
	dataEndDate: '1977-05-31',
	isExactMatch: true,
	customerTopLevelName: 'Rebel Alliance',
	customerGroup: 'Mos Eisley Cantina',
	customerGroupPlid: 'CL-1138',
	customerLocationName: 'Chalmuns Cantina',
	customerLocationPlid: 'LOC-2187',
	purchaseDistributorCompany: 'Figrin D an and the Modal Nodes',
	purchaseDistributorCompanyPlid: 'DST-1977',
	purchaseDistributorLocation: 'Docking Bay 94',
	purchaseDistributorLocationPlid: 'DSTLOC-94',
	purchaseDescription: 'Blue Milk 5lb',
	purchaseCategory: 'Dairy',
	purchaseManufacturerName: 'Lars Homestead',
	purchaseManufacturerPlid: 'MFR-TATOOINE',
	purchaseManufacturerProductDmid: 197705,
	purchaseDistributorProductDmid: 1138,
	purchaseMin: 'MIN-BLUE-MILK',
	purchaseDin: 'DIN-2187',
	purchaseBrand: 'Tatooine Dairy',
	purchaseBrandType: 'National',
	purchasePack: '6/32 OZ',
	purchaseInvUnit: 'CASE',
	purchaseInvQuantity: 12,
	purchaseTotalSpend: 480.5,
	purchaseUnitPrice: 40.04,
	matchQuality: 0.97,
	conversionRanking: 1,
	matchSource: 'EXACT',
	matchVerified: true,
	stockItem: true,
	exclusionProgramTypes: null,
	matchedDescription: 'Blue Milk 1 gal',
	matchedManufacturerName: 'Lars Homestead',
	matchedManufacturerPlid: 'MFR-TATOOINE',
	matchedManufacturerProductDmid: 197706,
	matchedDistributorProductDmid: 1139,
	matchedMin: 'MIN-BLUE-MILK-GAL',
	matchedDin: 'DIN-2188',
	matchedBrand: 'Tatooine Dairy',
	matchedBrandType: 'National',
	matchedPack: '4/1 GAL',
	matchedPackConversion: 0.5,
	matchedEnableConversion: true,
	directDeal: false,
	sendingDeviations: true,
	contractId: 'CTR-ALDERAAN',
	contractTermSetId: 'TS-LEIA',
	contractTermSetName: 'Alderaan Terms',
	contractName: 'Princess Leia Contract',
	contractTier: 'Gold',
	contractValueType: 'DEV',
	contractDeviatedPrice: 32.1,
	contractAdjustedDeviatedPrice: 31.5,
	markupType: 'PERCENT_MARKUP',
	markupAmount: 5,
	priceWithMarkup: 33.08,
	enablePrice: true,
	contractUnitSavings: 6.96,
	contractExtendedSavings: 83.52,
	contractAnnualSavings: 1002.24,
	hasRebate: true,
	rebateId: 'RBT-YAVIN',
	rebateOwner: 'Mon Mothma',
	rebateTermSetId: 'TS-REBATE',
	rebateTermSetName: 'Yavin Rebate',
	rebateDescription: 'Alliance volume rebate',
	rebateTier: '1',
	rebateValueType: 'PER_CASE',
	rebateMemberValue: 1.25,
	enableRebate: true,
	rebateUnitSavings: 1.25,
	rebateExtendedSavings: 15,
	rebateAnnualSavings: 180,
	exactItemRebate: 1.25,
	exactExtendedRebate: 15,
	rebateDifference: 0,
	rebateAnnualDifference: 0,
	totalSavings: 98.52,
	annualSavings: 1182.24,
	entegraApplicable: false,
	...overrides,
})

export const opportunities: Opportunity[] = [
	opportunity(),
	opportunity({
		id: 2,
		sourceRelativePath: enterpriseFileName,
		dataStartDate: '1977-09-01',
		dataEndDate: '1977-09-30',
		isExactMatch: false,
		customerTopLevelName: 'United Federation of Planets',
		customerGroup: 'USS Enterprise',
		customerGroupPlid: 'CL-1701',
		customerLocationName: 'NCC-1701',
		customerLocationPlid: 'LOC-1701',
		purchaseDescription: 'Romulan Ale 1.75L',
		purchaseCategory: 'Beverage',
		purchaseManufacturerName: 'Romulan Star Empire',
		purchaseManufacturerProductDmid: 1701,
		matchedDescription: 'Synthehol Ale 1.75L',
		matchSource: 'SIMILAR',
		matchVerified: false,
		contractName: 'Kirk Contract',
		rebateOwner: 'Spock',
		totalSavings: 42,
		annualSavings: 504,
	}),
	opportunity({
		id: 3,
		sourceRelativePath: ziggyFileName,
		dataStartDate: '1972-05-01',
		dataEndDate: '1972-05-31',
		isExactMatch: false,
		customerTopLevelName: 'Mainman',
		customerGroup: 'Spiders From Mars',
		customerGroupPlid: 'CL-1972',
		customerLocationName: 'Rainbow Theatre',
		purchaseDescription: 'Moonage Daydream 6/32 OZ',
		purchaseManufacturerName: 'David Bowie',
		purchaseManufacturerProductDmid: 1972,
		matchedDescription: 'Starman 12/16 OZ',
		matchSource: 'CONVERSION',
		contractName: 'Ziggy Contract',
		rebateOwner: 'Mick Ronson',
		markupType: 'FEE_PER_CASE',
		totalSavings: 12.5,
		annualSavings: 150,
	}),
]

export const opportunitiesRes: PaginatedAPIRes<Opportunity[]> = {
	data: opportunities.filter((row) => row.sourceRelativePath === tatooineFileName),
	pagination: {
		page: 1,
		pageSize: 100,
		total: 1,
		totalPages: 1,
	},
}
